<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

    <sonicu-header>
      Add Banner
    </sonicu-header>

    <div class="md:grid md:grid-cols-3 md:gap-6">

      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <span class="text-lg font-medium leading-6 text-gray-900">
            Company
          </span>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Select the company that the banner will be displayed to. If you would like the banner to be displayed to all descendants of the selected company, check the box below.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid max-w-2xl grid-cols-4 gap-x-6 gap-y-8">
              <div class="mb-6 col-span-4">
                <label for="companies" class="block mb-2 text-sm font-medium text-gray-900">
                  Company
                </label>
                <select2
                  v-model:value="form.company_id"
                  id="companies"
                  placeholder="Select Company"
                  :options="companies"
                  :close-on-select="true"
                >
                </select2>
                <label class="inline-flex items-center cursor-pointer mt-4">
                  <input type="checkbox" v-model="form.apply_to_descendants" class="sr-only peer">
                  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                  <span class="ms-3 text-sm font-medium text-gray-900">Apply to Descendants</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <span class="text-lg font-medium leading-6 text-gray-900">
            Banner Message
          </span>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Enter the message that will be displayed on the banner.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid max-w-2xl grid-cols-4 gap-x-6 gap-y-8">
              <div class="mb-6 col-span-4">
                <label for="banner_message" class="block mb-2 text-sm font-medium text-gray-900">
                  Banner Message
                </label>
                <input v-model="form.banner_message" type="text" id="banner_message" placeholder="Enter a message" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <span class="text-lg font-medium leading-6 text-gray-900">
            Banner Link
          </span>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Enter the link that the banner will redirect to.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid max-w-2xl grid-cols-4 gap-x-6 gap-y-8">
              <div class="mb-6 col-span-4">
                <label for="banner_link" class="block mb-2 text-sm font-medium text-gray-900">
                  Banner Link
                </label>
                <input v-model="form.banner_link" type="text" id="banner_link" placeholder="https://sonicu.com/support" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="flex justify-end pt-5">
      <button @click="createBanner" type="submit" name="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none">Create New Banner</button>
      <a href="/SonicuTools/banners" class="hover:text-gray-900 hover:no-underline text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2">Cancel</a>
    </div>
  </div>
</template>

<script>
import SonicuHeader from "../elements/SonicuHeader.vue";
import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";
import axios from "axios";
import Select2 from "../elements/select2.vue";

export default {
  name: 'BannerCreate',
  mixins: [SonicuCoreMixin],
  components: {Select2, SonicuHeader},
  props: {
    companies: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      form: {
        company_id: '',
        apply_to_descendants: false,
        banner_message: '',
        banner_link: ''
      }
    }
  },
  methods: {
    createBanner() {
      axios.post('/api-internal/SonicuTools/banners', this.form)
        .then(response => {
          window.location.href = '/SonicuTools/banners';
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
}
</script>